import storage from '@/plugins/storage';

export default async (to, from, next) => {
  if (storage.get('NEW_APP_BY_DEFAULT')) {
    next({ name: 'newapp' });
  } else {
    next();
  }
};
